import React from 'react';
import { Button } from '@parsina/framework';
import { C } from '@parsina/framework/tokens';

/**
 * The doctor onboarding wizard's primitives, for the clinic's.
 *
 * The doctor app (src/screens/Onboarding) is the reference for how a new
 * user's first screens look in every Parsina panel. These are its step heading
 * and its `Btn`, so a clinic owner and a doctor meet the same type ramp and the
 * same buttons on day one. Change them there first.
 */

/** «مشخصات …» — the step's own heading: 15/700 over a 12px line. */
export function StepHeading({ id, title, subtitle }) {
  return (
    <div style={{ marginBottom: 14 }}>
      <h2 id={id} style={{ margin: '0 0 4px', fontSize: 15, fontWeight: 700, color: C.textPrimary }}>{title}</h2>
      {subtitle ? (
        <div style={{ fontSize: 12, color: C.textSecondary, lineHeight: 1.8 }}>{subtitle}</div>
      ) : null}
    </div>
  );
}

/**
 * The doctor's `Btn`: the kit Button at `lg`, bold, never shorter than the 44px
 * hit-target floor, and — for the primary — the brand sweep.
 */
export const PrimaryAction = React.forwardRef(function PrimaryAction(
  { secondary = false, fullWidth = false, className = '', ...props },
  ref,
) {
  return (
    <Button
      ref={ref}
      variant={secondary ? 'outline' : 'default'}
      size="lg"
      className={`min-h-11 font-bold whitespace-nowrap${fullWidth ? ' w-full' : ''}${secondary ? '' : ' bg-gradient-brand'} ${className}`.trim()}
      {...props}
    />
  );
});
